import { render, staticRenderFns } from "./PromotionSimpleCondition.vue?vue&type=template&id=1dc12912&"
import script from "./PromotionSimpleCondition.vue?vue&type=script&lang=ts&"
export * from "./PromotionSimpleCondition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports